import { useCreateBlockNote } from "@blocknote/react";
import "@blocknote/mantine/style.css";
import "@blocknote/core/fonts/inter.css";
import { Map } from '@vis.gl/react-maplibre';
import { BlockNoteView } from "@blocknote/mantine";

export default function ViewParamField({ value, fieldType, placeholder, onClick, className = "" }) {

  if (!value && fieldType === "map") return (<></>)
  if (!value) return (<EmptyField onClick={onClick} className={`text-gray-400 italic ${className}`}>
    {placeholder}
  </EmptyField>)

  if (fieldType === "map") {
    const initialViewState = JSON.parse(value);
    return (<Map
      initialViewState={{
        longitude: initialViewState.longitude || -100,
        latitude: initialViewState.latitude || 40,
        zoom: initialViewState.zoom || 3.5
      }}
      style={{ width: '100%', height: 400 }}
      mapStyle={`https://api.maptiler.com/maps/streets/style.json?key=${import.meta.env.VITE_MAP_KEY}`}
    />)
  }

  if (fieldType === "longtext") {
    let jsonParsed;

    try {
      jsonParsed = value ? JSON.parse(value) : undefined;
    } catch (error) {
      console.error("Error parsing JSON value:", error);
      jsonParsed = undefined;
    }
    const editor = useCreateBlockNote({
      initialContent: jsonParsed ? jsonParsed : undefined,
      readOnly: true,
      enableImageUploads: false,
      enableFileUploads: false,
      enableLinks: false,
      enableMentions: false,
      enableBlockStyles: false,
      enableBlockTypes: false
    })
    return (<EmptyField onClick={onClick} className={`text-gray-900 ${className}`}>
      <BlockNoteView
        editor={editor}
        theme="light"
        editable={false}
        formattingToolbar={false}
        sideMenu={false}
        slashMenu={false}
        linkToolbar={false}
        emojiPicker={false}
        filePanel={false}
        tableHandles={false}
      />
    </EmptyField>)
  }

  return (<EmptyField onClick={onClick} className={className}>
    <span className="font-medium break-all">{value}</span>
  </EmptyField>)
}


const EmptyField = ({ children, onClick, className = "" }) => (
  <button
    className={`text-left cursor-pointer hover:bg-gray-50 p-1 rounded transition-colors w-full ${className}`}
    onClick={onClick}
  >
    {children}
  </button>
)